import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../../model';
import Skeleton from '../../Skeleton/Skeleton';

import Filter from './Filter/Filter';
import Sidecar from './Sidecar/Sidecar';
import Table from './Table/Table';
import styles from './Tournaments.scss';

const Tournaments: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const isLoading = useSelector(widgetSelect.isLoading);

  return isLoading ? (
    <Skeleton variant="rectangular" sx={{ height: 250, width: '100%' }} />
  ) : (
    <div className={styles.root}>
      <Filter />
      <Table />
      <Sidecar />
    </div>
  );
};

export default Tournaments;
